"use client";

import { useTranslations } from "@i18n/provider";

const CATEGORY_STYLES: Record<string, string> = {
  error: "bg-coral-tint text-coral-fg",
  strength: "bg-speaking-tint text-speaking-fg",
  goal: "bg-reading-tint text-reading-fg",
  topic: "bg-writing-tint text-writing-fg",
  emotional: "bg-lavender-tint text-lavender-fg",
  preference: "bg-surface-sunk text-ink-muted",
  fluency: "bg-speaking-tint text-speaking-fg",
  vocab: "bg-reading-tint text-reading-fg",
  learner: "bg-lavender-tint text-lavender-fg",
};

type InsightCategoryBadgeProps = {
  category: string;
  sourceType?: string;
};

export function InsightCategoryBadge({ category, sourceType }: InsightCategoryBadgeProps) {
  const { t } = useTranslations();
  const isLearner = sourceType?.toLowerCase() === "learner";
  const key = isLearner ? "learner" : category.toLowerCase();
  const styles = CATEGORY_STYLES[key] ?? "bg-surface-sunk text-ink-muted";
  const labelKey = `profile.tutorMemory.category.${key}` as "profile.tutorMemory.category.error";
  const label = t(labelKey);
  const displayLabel = label === labelKey ? category : label;

  return (
    <span
      className={`rounded-full px-2.5 py-0.5 text-[0.6875rem] font-bold uppercase tracking-[0.08em] ${styles}`}
    >
      {displayLabel}
    </span>
  );
}
